// src/app/modules/Blacklist/database/column-formatters/index.js
import React from "react";
import Moment from "moment";
import { XCircle } from 'lucide-react';

export function VisitorColumnFormatter(cellContent, row) {
  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 14 }}>{row.visitor_name}</div>
      <div className="sety-tbl-sub">{row.visitor_phone}</div>
    </div>
  );
}

const REASON_ICONS = {
  theft: '💰',
  fraud: '🎭',
  assault: '⚠️',
  vandalism: '🔨',
  harassment: '😠',
  trespassing: '🚫',
  suspicious_activity: '👁️',
  policy_violation: '📋',
};

export function ReasonColumnFormatter(cellContent, row) {
  return (
    <div>
      <span style={{ marginRight: 8 }}>{REASON_ICONS[row.reason] || '⚠️'}</span>
      {row.reason?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
    </div>
  );
}

const SEVERITY_PILL = {
  critical: 'sety-pill-red',
  high: 'sety-pill-amber',
  medium: 'sety-pill-purple',
  low: 'sety-pill-green',
};

export function SeverityColumnFormatter(cellContent, row) {
  return (
    <span className={`sety-pill ${SEVERITY_PILL[row.severity] || 'sety-pill-grey'}`}>
      {row.severity?.toUpperCase() || row.severity}
    </span>
  );
}

const STATUS_PILL = {
  active: 'sety-pill-red',
  appealed: 'sety-pill-amber',
  expired: 'sety-pill-grey',
  removed: 'sety-pill-green',
};

export function StatusColumnFormatter(cellContent, row) {
  const label = row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : row.status;
  return (
    <span className={`sety-pill ${STATUS_PILL[row.status] || 'sety-pill-grey'}`}>
      {label}
    </span>
  );
}

export function ScopeColumnFormatter(cellContent, row) {
  if (row.share_with_network) {
    return <span className="sety-pill sety-pill-purple">🌐 Network</span>;
  }
  return <span className="sety-tbl-sub">Local</span>;
}

export function DateFormatter(cellContent, row) {
  if (!row.created_at) return <span className="sety-tbl-sub">—</span>;

  const date = Moment(row.created_at);
  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5 }}>{date.format('MMM DD, YYYY')}</div>
      <div className="sety-tbl-sub">{date.fromNow()}</div>
    </div>
  );
}

export function ExpiryFormatter(cellContent, row) {
  if (!row.expires_at) {
    return <span className="sety-tbl-sub">Never</span>;
  }

  const date = Moment(row.expires_at);
  const isExpired = date.isBefore(Moment());

  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5, color: isExpired ? 'var(--ink-500)' : 'var(--ink-900)' }}>
        {date.format('MMM DD, YYYY')}
      </div>
      <div className="sety-tbl-sub" style={{ color: isExpired ? 'var(--red)' : undefined }}>
        {isExpired ? 'Expired' : date.fromNow()}
      </div>
    </div>
  );
}

export function ActionsColumnFormatter(cellContent, row, rowIndex, { onRemove }) {
  if (row.status !== 'active') {
    return <span className="sety-tbl-sub">—</span>;
  }
  return (
    <button
      className="sety-btn sety-btn-danger"
      style={{ padding: '6px 10px' }}
      onClick={() => onRemove(row)}
      title="Remove from blacklist"
    >
      <XCircle size={15} />
    </button>
  );
}
